/* RESPONSIBLE TEAM: team-app-security */

export const EMAIL_SETTING_TYPES = Object.freeze({
  EMAIL_AUTO_REPLY: 'email_auto_reply',
  EMAIL_AUTO_REPLY_TEXT: 'email_auto_reply_text',
  USER_EMAIL_FOLLOW_UPS: 'user_email_follow_ups',
  USER_TICKET_EMAIL_FOLLOW_UPS: 'user_ticket_email_follow_ups',
  EMAIL_NOTIFICATION_DESTINATION_URL: 'email_notification_destination_url',
});
